import React, { useState, useEffect } from 'react';
import { useComic } from './ComicContext';
import './PageInfoForm.css';
import balumIcon from '../../src/assets/icons/balum-icon-transparent.png';

const PageInfoForm = ({ onComplete, onCancel }) => {
  const { createComic, saveToLocalStorage, clearCurrentComic } = useComic();

  const [formData, setFormData] = useState({
    title: '',
    author: '',
    totalPages: '',
    category: ''  // Changed from filter to category
  });

  const [language, setLanguage] = useState({
    portugues: true,
    libras: true,
    english: false,
    asl: false
  });

  // Ensure form is reset when component mounts
  useEffect(() => {
    // Clear any current comic selection when form opens
    clearCurrentComic();
    // Reset form data
    setFormData({
      title: '',
      author: '',
      totalPages: '',
      category: ''
    });
    setLanguage({
      portugues: true,
      libras: true,
      english: false,
      asl: false
    });
  }, [clearCurrentComic]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // const handleLanguageToggle = (lang) => {
  //   setLanguage(prev => ({
  //     ...prev,
  //     [lang]: !prev[lang]
  //   }));
  // };

  const handleSave = async () => {
    if (!formData.title.trim() || !formData.author.trim() || !formData.totalPages) {
      alert('Por favor, preencha todos os campos.');
      return;
    }
    if (isNaN(formData.totalPages) || parseInt(formData.totalPages) <= 0) {
      alert('Por favor, insira um número válido de páginas.');
      return;
    }

    // Normalize categories: split by comma or whitespace, filter out empty strings, join back
    const normalizedCategory = formData.category
      .split(/[\s,]+/)
      .filter(cat => cat !== '')
      .join(', ');

    const metadata = {
      title: formData.title.trim(),
      author: formData.author.trim(),
      totalPages: parseInt(formData.totalPages),
      category: normalizedCategory,  // Normalized comma-separated categories
      languages: language
    };

    try {
      // Create comic via context (now async)
      await createComic(metadata);

      // Save to localStorage
      saveToLocalStorage();

      // Notify parent component
      if (onComplete) {
        onComplete(metadata);
      }
    } catch (error) {
      console.error('Error creating comic:', error);
      alert('Erro ao criar quadrinho. Verifique se o servidor está rodando.');
    }
  };

  const handleCancel = () => {
    // Reset form data
    setFormData({
      title: '',
      author: '',
      totalPages: '',
      category: ''
    });
    setLanguage({
      portugues: true,
      libras: true,
      english: false,
      asl: false
    });

    // Navigate back to list view
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="page-info-form-container">
      <div className="page-info-card">
        {/* Logo */}
        <div className="balum-logo">
          <img src={balumIcon} alt="balum" className="logo-img" />
        </div>

        {/* Form Content */}
        <div className="form-content">
          {/* Title Field */}
          <div className="form-row">
            <label className="form-label">
              TÍTULO:
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="form-input"
              placeholder="01_Angústia"
            />
          </div>

          {/* Author Field */}
          <div className="form-row">
            <label className="form-label">
              AUTOR:
            </label>
            <input
              type="text"
              name="author"
              value={formData.author}
              onChange={handleChange}
              className="form-input"
              placeholder="PEDRO HENRIQUE"
            />
          </div>

          {/* Category Field */}
          <div className="form-row">
            <label className="form-label">
              CATEGORIA:
            </label>
            <input
              type="text"
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="form-input"
              placeholder="Ex: terror, romance, aventura (separados por vírgula)"
            />
          </div>

          {/* Bottom Row with Pages, Status, and Languages */}
          <div className="bottom-row">
            {/* Pages and Status */}
            <div className="left-section">
              <div className="field-group">
                <label className="form-label">
                  NO. PÁGINAS:
                </label>
                <input
                  type="number"
                  name="totalPages"
                  value={formData.totalPages}
                  onChange={handleChange}
                  className="pages-input"
                  placeholder="15"
                  min="1"
                />
              </div>

              {/* <div className="field-group">
                <label className="form-label">
                  STATUS:
                </label>
                <div className="status-checkbox"></div>
              </div> */}

            </div>

            {/* Language Checkboxes */}
            {/* <div className="language-section">
              <div className="language-item">
                <div>
                  <label className="language-label active">
                    PORTUGUÊS
                  </label>
                </div>
                <div>
                  <button
                    onClick={() => handleLanguageToggle('portugues')}
                    className="language-checkbox"
                  >
                    {language.portugues && <span className="checkbox-mark">×</span>}
                  </button>
                </div>
              </div>

              <div className="language-item">

                <div>
                  <label className="language-label active">
                    LIBRAS
                  </label>
                </div>

                <div>
                  <button
                    onClick={() => handleLanguageToggle('libras')}
                    className="language-checkbox"
                  >
                    {language.libras && <span className="checkbox-mark">×</span>}
                  </button>
                </div>

              </div>
              <div className="language-item">

                <div>
                  <label className="language-label">
                    ENGLISH
                  </label>
                </div>

                <div>
                  <button
                    disabled
                    onClick={() => handleLanguageToggle('english')}
                    className="language-checkbox disabled"
                  >
                    {language.english && <span className="checkbox-mark">×</span>}
                  </button>
                </div>

              </div>
              <div className="language-item">
                <div>
                  <label className="language-label">
                    ASL
                  </label>
                </div>

                <div>
                  <button
                    disabled
                    onClick={() => handleLanguageToggle('asl')}
                    className="language-checkbox disabled"
                  >
                    {language.asl && <span className="checkbox-mark">×</span>}
                  </button>
                </div>

              </div>
            </div> */}
          </div>
        </div>

        {/* Action Buttons */}
        <div className='initial-buttons-container'>
        <div className="action-buttons-initial">
          
          {/* <button className="action-button" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
            <div className="button-circle open">
              <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <span className="button-label">ABRIR</span>
          </button>

          <button className="action-button" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
            <div className="button-circle edit">
              <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
            </div>
            <span className="button-label">EDITAR</span>
          </button> */}

          <button onClick={handleSave} className="action-button">
            <div className="button-circle save">
              <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span className="button-label">SALVAR</span>
          </button>

          <button onClick={handleCancel} className="action-button">
            <div className="button-circle cancel">
              <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <span className="button-label">CANCELAR</span>
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default PageInfoForm;
